import React, { useEffect, useState } from 'react';
import { useData } from '../../contexts';
import { DataGrid } from '@mui/x-data-grid';
import { Tooltip, TooltipTrigger, TooltipContent } from '../Tooltip/Tooltip';

export const DetailTable = (props: any) => {
  const { data, jaren } = props;
  const { colors, locale } = useData();

  const [columns, setColumns] = useState([]);

  const updateCols = () => {
    const tmpCols = [{ field: 'gemeente', headerName: '', width: 180 }];
    jaren.forEach((d: any) => {
      tmpCols.push({
        field: d,
        headerName: d,
        width: 120,
        type: 'number',

        renderCell: (params: any) => {
          return (
            <>
              <Tooltip>
                <TooltipTrigger>
                  <p>
                    {params.value === undefined || params.value === null
                      ? '-'
                      : data[0] && data[0].d3format
                      ? locale.format(data[0].d3format)(params.value)
                      : params.value}
                  </p>
                </TooltipTrigger>
                <TooltipContent className="Tooltip">
                  <p>{params.row.gemeente}</p>
                </TooltipContent>
              </Tooltip>
            </>
          );
        },
      });
    });

    setColumns(tmpCols);
  };

  useEffect(() => {
    updateCols();
  }, [data, jaren]);

  return (
    <div
      id="detailTabel"
      style={{
        width: '100%',
        height: '100%',
        minHeight: '100px',
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        hideFooter={true}
        density={'compact'}
        disableColumnMenu
        disableRowSelectionOnClick
        sx={{
          boxShadow: 0,
          border: '1px solid #f1f1f1',
          backgroundColor: '#FFF',
          padding: '1rem',
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell': {
            cursor: 'pointer',
            border: 'none',
            outline: 'none',
            '&:focus': {
              outline: 'none',
            },
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0.8em',
            height: '0.8em',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
          '& .MuiDataGrid-virtualScroller': {
            // scrollbarColor: 'red blue',
            scrollbarWidth: 'thin',
          },
        }}
      />
    </div>
  );
};

export const DetailTableMobile = (props: any) => {
  const { data, jaren } = props;
  const { colors, locale } = useData();

  const [columns, setColumns] = useState([]);

  const updateCols = () => {
    const tmpCols = [{ field: 'gemeente', headerName: '', width: 140 }];
    jaren.forEach((d: any) => {
      tmpCols.push({
        field: d,
        headerName: d,
        width: 80,
        type: 'number',

        renderCell: (params: any) => {
          return (
            <>
              <Tooltip>
                <TooltipTrigger style={{ fontSize: '11px' }}>
                  <p>
                    {params.value === undefined || params.value === null
                      ? '-'
                      : data[0] && data[0].d3format
                      ? locale.format(data[0].d3format)(params.value)
                      : params.value}
                  </p>
                </TooltipTrigger>
                <TooltipContent
                  className="Tooltip"
                  style={{ fontSize: '11px' }}
                >
                  <p>{params.row.gemeente}</p>
                </TooltipContent>
              </Tooltip>
            </>
          );
        },
      });
    });

    setColumns(tmpCols);
  };

  useEffect(() => {
    updateCols();
  }, [data, jaren]);

  return (
    <div
      id="detailTabel"
      style={{
        width: '100%',
        height: '100%',
        minHeight: '100px',
      }}
    >
      <DataGrid
        rows={data}
        columns={columns}
        hideFooter={true}
        density={'compact'}
        disableColumnMenu
        disableRowSelectionOnClick
        sx={{
          fontSize: '11px',
          boxShadow: 0,
          border: '1px solid #f1f1f1',
          backgroundColor: '#FFF',
          padding: '1rem',
          '& .MuiDataGrid-columnHeader:focus': {
            outline: 'none',
          },
          '& .MuiDataGrid-cell': {
            cursor: 'pointer',
            border: 'none',
            outline: 'none',
            '&:focus': {
              outline: 'none',
            },
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': {
            width: '0.8em',
            height: '0.8em',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-track': {
            background: '#f1f1f1',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb': {
            backgroundColor: '#888',
          },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb:hover': {
            background: '#555',
          },
          '& .MuiDataGrid-virtualScroller': {
            // scrollbarColor: 'red blue',
            scrollbarWidth: 'thin',
          },
        }}
      />
    </div>
  );
};
